let eventSrcUrl = null;

/**
 * Returns `true` if the given element is in a horizontal RTL writing mode.
 * @param {HTMLElement} element
 */
const isRtl = element => window.getComputedStyle(element).direction === 'rtl';

class Carousel {
    constructor(props) {
        if (!props.root) {
            return;
        }

        const createDotButtons = () => {
            const dotContainer = document.createElement('ol');

            dotContainer.classList.add('jdg-carousel-dots');
            dotContainer.setAttribute('role', 'list');
            dotContainer.setAttribute('aria-label', 'Jump to Slide Buttons');

            this.slides.forEach((slide, index, array) => {
                const dotItem = document.createElement('li');
                const dotButton = document.createElement('button');
                const dotButtonSRText = document.createElement('span');

                if (index === 0) {
                    dotButton.classList.add('active');
                }

                dotItem.setAttribute('data-index', index);
                dotButtonSRText.innerHTML = `<span class="jdg-sr-only">Slide ${
                    index + 1
                } of ${array.length}</span>`;

                dotButton.addEventListener('click', () => this.handleDotClick(index));

                dotButton.appendChild(dotButtonSRText);
                dotItem.appendChild(dotButton);
                dotContainer.appendChild(dotItem);
            });

            this.carousel.appendChild(dotContainer);

            return dotContainer;
        };

        this.handleNavClick = this.handleNavClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleDotClick = this.handleDotClick.bind(this);

        this.carousel = props.root;
        this.scrollContainer = this.carousel.querySelector(
            '.jdg-carousel-scroll-container'
        );
        this.live = this.carousel.querySelector('.jdg-carousel-live');
        this.slidesList = this.scrollContainer.querySelector(
            '.jdg-carousel-slides'
        );
        this.slides = this.slidesList.querySelectorAll('.jdg-carousel-slide');

        if (this.slides <= 1) {
            return;
        }

        this.slides.forEach((slide, index) => {
            if (index === 0) {
                return;
            }

            slide.setAttribute('aria-hidden', 'true');
        });

        this.dotContainer = createDotButtons();
        this.controls = this.carousel.querySelector('.jdg-carousel-controls');
        this.navControlPrevious = this.controls.querySelector('.start');
        this.navControlNext = this.controls.querySelector('.end');

        this.navControlPrevious.addEventListener('click', () =>
            this.handleNavClick('start')
        );
        this.navControlNext.addEventListener('click', () =>
            this.handleNavClick('end')
        );
        this.scrollContainer.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    }

    handleScroll() {
        const scrollLeft = Math.abs(this.scrollContainer.scrollLeft);
        const width = this.scrollContainer.clientWidth + 1;
        const isAtStart = Math.floor(scrollLeft) === 0;
        const isAtEnd =
      Math.ceil(width + scrollLeft) >= this.scrollContainer.scrollWidth;

        this.navControlPrevious.disabled = isAtStart;
        this.navControlNext.disabled = isAtEnd;
    }

    /**
   * @param {number} index Index of the dot and respective slide.
   */
    handleDotClick(index) {
        const dots = this.dotContainer.querySelectorAll('button');

        dots.forEach((dot, dotIndex) =>
            dotIndex === index
                ? dot.classList.add('active')
                : dot.classList.remove('active')
        );

        const rawHtml = this.slides[index].querySelector(
            '.jdg-carousel-quote'
        ).innerHTML;
        const liveHtml = rawHtml.replace(/[\r\n]/gm, '');

        this.slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center'});
        this.live.setAttribute(
            'aria-label',
            `Slide ${index + 1} of ${this.slides.length}`
        );
        this.live.innerHTML = liveHtml;
    }

    /**
   * @param {'start'|'end'} direction
   */
    handleNavClick(direction) {
        const previousDot = this.dotContainer.querySelector('button.active');
        const previousDotItem = previousDot.parentNode;

        const activeDotItem =
      direction === 'start'
          ? previousDotItem.previousSibling
          : previousDotItem.nextSibling;

        if (!activeDotItem) {
            return;
        }

        const activeDot = activeDotItem.querySelector('button');
        const { index } = activeDotItem.dataset;
        const parsedIndex = parseInt(index, 10);

        const rawHtml = this.slides[index].querySelector(
            '.jdg-carousel-quote'
        ).innerHTML;
        const liveHtml = rawHtml.replace(/[\r\n]/gm, '');

        previousDot.classList.remove('active');
        activeDot.classList.add('active');

        let scrollAmount = this.scrollContainer.clientWidth;

        scrollAmount = isRtl(this.scrollContainer) ? -scrollAmount : scrollAmount;
        scrollAmount = direction === 'start' ? -scrollAmount : scrollAmount;

        this.scrollContainer.scrollBy({ left: scrollAmount });
        this.live.setAttribute(
            'aria-label',
            `Slide ${parsedIndex + 1} of ${this.slides.length}`
        );
        this.live.innerHTML = liveHtml;
    }
}

document.addEventListener('DOMContentLoaded', event => {
    if (eventSrcUrl !== event.target.URL) {
        eventSrcUrl = event.target.URL;

        const quoteCarousel = new Carousel({
            root: document.querySelector('#jdg-quotes-carousel')
        });

        return quoteCarousel;
    }
});
